var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.144287,
    y: 0.0898438,
    width: 42,
    height: 42,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7991 11.7461H29.8914L23.1355 19.4676L31.0833 29.9749H24.8603L19.9862 23.6023L14.4091 29.9749H11.3149L18.5409 21.7158L10.9166 11.7461H17.2976L21.7034 17.5709L26.7991 11.7461ZM25.7137 28.124H27.4273L16.3666 13.4998H14.5278L25.7137 28.124Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/XIcon.b97462403d5c4f0550ad89f3dc5d3b9c.svg";
export { ForwardRef as ReactComponent };